import lib from '@/library'
import config from '@/config'

export default {
  computed: {
    brand_default () {
      return lib.cdu.brands.isDefault()
    },
    brand_white () {
      return lib.cdu.brands.isWhite()
    },
    brand_white1 () {
      return lib.cdu.brands.isWhite1()
    },
    brand_translux () {
      return lib.cdu.brands.isTranslux()
    },
    brand_translux1 () {
      return lib.cdu.brands.isTranslux1()
    },
    brand_translux2 () {
      return lib.cdu.brands.isTranslux2()
    },
    brand_translux3 () {
      return lib.cdu.brands.isTranslux3()
    },
    brand_translux4 () {
      return lib.cdu.brands.isTranslux4()
    },
    brand_pinegreen () {
      return lib.cdu.brands.isPinegreen()
    },
    brand_darkviolet () {
      return lib.cdu.brands.isDarkviolet()
    },
    brand_translux5 () {
      return lib.cdu.brands.isTranslux5()
    },
    brand_ultrawide () {
      return lib.cdu.brands.isUltraWide()
    },
    current_brand_cnfiguration () {
      return (config.app.cdu && config.app.cdu[lib.cdu.urlParameters.getBrand()]) || {}
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Brands.js